<div class="expanded-panel-header blue" (click)="toggleExpand()">KPIs</div>
@if(expanded){
  @for(row of rows; track $index){
    <div class="row" style="padding-left: 8px;padding-right: 8px;">
      @for(field of row; track field.key){
        <div class="col-md-6">
          <div class="row align-top" style="border-bottom: 1px solid lightgray">
            <div class="col-md-6 label">{{ field.label }}</div>
            @switch(field.key){
              @case ('total_equity'){
                @if(detail[field.key]!==null){
                  <div class="col-md-6">{{ detail[field.key] | currency: 'USD': 'symbol': '1.0-0'}}</div>
                }
                @if(detail[field.key]==null){
                  <div class="col-md-6">--</div>
                }
              }
              @default {
                @if(detail[field.key]!==null){
                  <div class="col-md-6">{{ detail[field.key] | percent: '1.4-4'}}</div>
                }
                @if(detail[field.key]==null){
                  <div class="col-md-6">--</div>
                }
              }
            }
          </div>
        </div>
      }
    </div>
  }
}
